import React, { useCallback } from "react";
import Fonts from "../../../Config/Fonts";
import Colors from "../../../theme/Colors";
import Strings from "../../../Config/Strings";

const StateItemTable = ({
  tableHeaderData,
  mainHeadingText,
  tableBodyData,
}) => {
  const TableBodyComponent = useCallback(
    () => (
      <tbody>
        {tableBodyData?.map((tableContent, index) => (
          <tr key={tableContent?.id}>
            <td
              style={
                index === tableBodyData.length - 1
                  ? { ...tableDataStyle, borderBottom: "none" } // Remove bottom border for the last row
                  : tableDataStyle
              }
            >
              {tableContent?.items}
            </td>
            <td
              style={
                index === tableBodyData.length - 1
                  ? { ...tableDataStyle, borderBottom: "none" } // Remove bottom border for the last row
                  : tableDataStyle
              }
            >
              {tableContent?.quantity}
            </td>
            <td
              style={
                index === tableBodyData.length - 1
                  ? { ...tableDataStyle, borderBottom: "none" } // Remove bottom border for the last row
                  : tableDataStyle
              }
            >
              {tableContent?.client}
            </td>
          </tr>
        ))}
      </tbody>
    ),
    [tableBodyData]
  );

  const TableHeaderComponent = useCallback(
    () => (
      <thead>
        {tableHeaderData?.map((tableContent, index) => (
          <th key={index} style={tableHeaderStyle}>
            {tableContent?.header}
          </th>
        ))}
      </thead>
    ),
    [tableHeaderData]
  );

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>{mainHeadingText}</div>

      <div style={outerWrapper}>
        <div style={tableWrapper}>
          {tableBodyData?.length === 0 ||
          tableBodyData?.length === undefined ||
          tableBodyData?.length === null ? (
            <div style={{marginTop: '40%'}}>
              <span style={noDataTextStyle}>{Strings.NoDataFound}</span>
            </div>
          ) : (
            <table style={table}>
              <TableHeaderComponent />
              <TableBodyComponent />
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

const containerStyle = {
  width: "100%",
  height: "100%",
  backgroundColor: Colors.white,
  boxSizing: "border-box",
  borderLeft: "1px solid #ccc",
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
  borderBottomLeftRadius: "20px",
  borderBottomRightRadius: "20px",
  marginBottom: "20px",
};

const headerStyle = {
  textAlign: "center",
  fontSize: 14,
  fontWeight: 600,
  fontFamily: Fonts.Poppins,
  color: Colors.white,
  backgroundColor: Colors.adminPrimaryColor,
  padding: "15px",
  margin: "0",
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
};

const tableHeaderStyle = {
  fontSize: 12,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.breadCrumbsColor,
  position: "sticky",
  top: 0,
  textAlign: "center",
  padding: 9,
  paddingTop: "10px",
  paddingBottom: "10px",
  borderBottom: "1px solid #ccc",
};

const outerWrapper = {
  borderRadius: "4px",
  width: "100%",
};

const tableWrapper = {
  height: "100%",
  width: "100%",
  paddingBottom: "5px",
};

const noDataTextStyle = {
  fontSize: 13,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.breadCrumbsColor,
};

const table = {
  minWidth: "100%",
  borderCollapse: "separate",
  borderSpacing: "0px",
};

const tableDataStyle = {
  fontSize: 12,
  fontWeight: 500,
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  padding: "10px 8px",
  borderBottom: "1px solid #ccc",
};

export default StateItemTable;
